// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fR0Az","buttons":"styles_buttons__263Kh"};